import React from "react";
import Title from "./components/Title"; // Adjust the import path as needed
import Tag from "./components/Tag";

// Common Styles
const commonContainerStyle = {
  backgroundColor: "red",
  backgroundSize: "cover",
  borderRadius: 12,
  margin: "0.5rem",

  padding: "8px 0px",
  position: "relative",
  zIndex: 10,
  width: "auto",
  height: "auto",
};

const commonOverlayStyle = {
  position: "absolute",
  zIndex: 15,
  top: 0,
  left: 0,
  opacity: 0.5,
  borderRadius: 12,
  background: "linear-gradient(0deg, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.2))",
};

const commonTitleContainerStyle = {};

// Specific Styles
const getVerticalStyle = (imageUrl) => ({
  background: `url('${imageUrl}') no-repeat center center`,
  ...commonContainerStyle,
  height: 260,
  minWidth: "175px",
});

const verticalOverlayStyle = {
  height: "260px",
  width: "100%",
  ...commonOverlayStyle,
};

const verticalTitleContainerStyle = {
  top: "200px",
  ...commonTitleContainerStyle,
};

const getHorizontalStyle = (imageUrl) => ({
  background: `url('${imageUrl}') no-repeat center center`,
  ...commonContainerStyle,
  height: 175,
  minWidth: "260px",
});

const horizontalOverlayStyle = {
  ...commonOverlayStyle,
  width: "100%",
  height: "175px",
};

const horizontalTitleContainerStyle = {
  top: "112px",
  ...commonTitleContainerStyle,
};

// PromotionItem Component
function PromotionItem({
  language,
  title,
  showTag = false,
  tagPosition = ["top", "right"],
  tagBg = "#0099CC",
  tagColor = "#fff",
  tagText = " ",
  imageUrl,
  orientation = "vertical",
  callback = null,
}) {
  const containerStyle =
    orientation === "vertical"
      ? getVerticalStyle(imageUrl)
      : getHorizontalStyle(imageUrl);
  const overlayStyle =
    orientation === "vertical" ? verticalOverlayStyle : horizontalOverlayStyle;
  const titleLanguageStyle =
    language === "arabic" ? { textAlign: "right" } : { textAlign: "left" };
  const titleContainerStyle =
    orientation === "vertical"
      ? { ...verticalTitleContainerStyle, ...titleLanguageStyle }
      : { ...horizontalTitleContainerStyle, ...titleLanguageStyle };

  return (
    <div style={containerStyle} onClick={callback}>
      {showTag && (
        <Tag
          tagBg={tagBg}
          tagText={tagText}
          tagPosition={tagPosition}
          tagColor={tagColor}
        />
      )}
      <Title title={title} additionalStyles={titleContainerStyle} />
      <div style={overlayStyle}></div>
    </div>
  );
}

export default PromotionItem;
